import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  getNotification,
  getIsShowingErrorPage,
  getErrorCode,
} from '@shared/selectors';
import updateIsDesktopLayout from '@shared/actions/updateIsDesktopLayout';
import { goBack } from '@shared/actions';

import Shell from './Shell';

const mapStateToProps = createStructuredSelector({
  notification: getNotification,
  isShowingErrorPage: getIsShowingErrorPage,
  errorCode: getErrorCode,
});

const mapDispatchToProps = {
  goBack,
  updateIsDesktopLayout,
};

export default connect(mapStateToProps, mapDispatchToProps)(Shell);
